<template>
    <div class="plus_div">
        <div id="__nuxt">
            <div id="__layout">
                <div data-v-20323194=""><!---->
                    <div class="body" data-v-20323194=""><!---->
                        <div class="full-page louplus-full-page" data-v-0329e14f="" data-v-20323194="">
                            <section class="banner-section" data-v-0329e14f="">
                                <div class="louplus-banner full-bg text-center color-fff"
                                     style="min-height:300px;background-repeat: round;"
                                     :style=" 'background-image: url('+plus_info.banner_image_url+');'"
                                     data-v-1fd82d8e="" data-v-0329e14f="">
                                    <div class="relative container" data-v-1fd82d8e="">
                                        <div class="row" data-v-1fd82d8e="">
                                            <div class="col" data-v-1fd82d8e="">
                                                <div class="meta-info" data-v-1fd82d8e=""><h1 class="name"
                                                                                              data-v-1fd82d8e="">
                                                    <img src="" class="louplus-logo"
                                                         data-v-1fd82d8e="">
                                                    <!--<span class="vertical-middle" data-v-1fd82d8e="">{{plus_info.title}}</span>-->
                                                </h1>
                                                    <h2 class="desc" data-v-1fd82d8e="">
                                                        {{plus_info.description}}
                                                    </h2>
                                                    <!--<h3 class="labs" data-v-1fd82d8e="">-->
                                                    <!--25 个实验 + 19 个挑战 + 1 个项目挑战比赛-->
                                                    <!--</h3>-->
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row justify-center" data-v-1fd82d8e="">
                                            <!--<div class="col-md-2" data-v-1fd82d8e="">-->
                                                <!--<div class="summary-item open-time" data-v-1fd82d8e=""><p-->
                                                        <!--class="font-18"-->
                                                        <!--data-v-1fd82d8e="">-->
                                                    <!--开课时间-->
                                                <!--</p>-->
                                                    <!--<p class="font-16 bold no-margin" data-v-1fd82d8e="">-->
                                                        <!--{{plus_info.start_time}}-->
                                                    <!--</p></div>-->
                                            <!--</div>-->
                                            <!--<div class="col-md-2" data-v-1fd82d8e="">-->
                                                <!--<div class="summary-item course-duration" data-v-1fd82d8e=""><p-->
                                                        <!--class="font-18"-->
                                                        <!--data-v-1fd82d8e="">-->
                                                    <!--课程时长-->
                                                <!--</p>-->
                                                    <!--<p class="font-16 bold no-margin" data-v-1fd82d8e="">-->
                                                        <!--{{plus_info.duration}}-->
                                                    <!--</p></div>-->
                                            <!--</div>-->
                                            <!--<div class="col-md-2" data-v-1fd82d8e="">-->
                                                <!--<div class="summary-item open-countdown" data-v-1fd82d8e=""><p-->
                                                        <!--class="font-18"-->
                                                        <!--data-v-1fd82d8e="">-->
                                                    <!--开课倒计时-->
                                                <!--</p>-->
                                                    <!--<p class="font-16 bold no-margin" data-v-1fd82d8e=""><span-->
                                                            <!--data-v-1fd82d8e="">{{countdown}}</span></p></div>-->
                                            <!--</div>-->
                                        </div>
                                        <!--<div class="row row-support" data-v-1fd82d8e="">-->
                                        <!--<div class="col" data-v-1fd82d8e=""><span class="service-item"-->
                                        <!--data-v-1525c382=""-->
                                        <!--data-v-1fd82d8e=""><img-->
                                        <!--src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAZVJREFUOBGFk6tOA0EUhlkuEseWwCs0ISgMIQ0hYFAYWjx1mIbwABgcDoXCAgaFoqJJFaaEYEhAFgNvgFi+fzKzO52ZLSf598z5z2Uu52w2UyNFUeS4WkBa8g0GWZZJRzIbMhTYALfwQ7ANli20HsqnGNb1QkAbfIEjsBBGirO+Efo49BsbRxd8AHeVZJxIYlbAJ2hPBEHoOtpldcIxxSA2Bzp9dU0M3bszJS/pIkdPoPc0x1TldxC9STLbI5Vjc3N1TS3u09ZfLyZa2qQr9Llz2pwn7JYKLYFyNghcBJsuWFpFUNfgAIyAL8o1J/JJrbfAPck9GV6RPcwep3gQH8o8xA9Ycw4CH0m+wT5Dz6GbwBW5Yx2KxuVNOyYfG/4CqL1jcBhmy4YvH9v4IZLthz8B+6kitlDVfktoIF9Boy4p5InVdGuIq4G0xfSf6Rf5d7qJadjYbriBsXHqf9MuHRANqDjr09vt+kUy39CaAB31FKyDPnAzpu7sgBdwSXef0aVEhZyHgkrU1GtgJRqTAQVcYUO6zx/qQjRF8qgk+QAAAABJRU5ErkJggg=="-->
                                        <!--alt="销售服务支持" data-v-1525c382=""> <span-->
                                        <!--data-v-1525c382="">开课后24小时内无条件退款</span></span></div>-->
                                        <!--<div class="col" data-v-1fd82d8e=""><span class="service-item"-->
                                        <!--data-v-1525c382=""-->
                                        <!--data-v-1fd82d8e=""><img-->
                                        <!--src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAZVJREFUOBGFk6tOA0EUhlkuEseWwCs0ISgMIQ0hYFAYWjx1mIbwABgcDoXCAgaFoqJJFaaEYEhAFgNvgFi+fzKzO52ZLSf598z5z2Uu52w2UyNFUeS4WkBa8g0GWZZJRzIbMhTYALfwQ7ANli20HsqnGNb1QkAbfIEjsBBGirO+Efo49BsbRxd8AHeVZJxIYlbAJ2hPBEHoOtpldcIxxSA2Bzp9dU0M3bszJS/pIkdPoPc0x1TldxC9STLbI5Vjc3N1TS3u09ZfLyZa2qQr9Llz2pwn7JYKLYFyNghcBJsuWFpFUNfgAIyAL8o1J/JJrbfAPck9GV6RPcwep3gQH8o8xA9Ycw4CH0m+wT5Dz6GbwBW5Yx2KxuVNOyYfG/4CqL1jcBhmy4YvH9v4IZLthz8B+6kitlDVfktoIF9Boy4p5InVdGuIq4G0xfSf6Rf5d7qJadjYbriBsXHqf9MuHRANqDjr09vt+kUy39CaAB31FKyDPnAzpu7sgBdwSXef0aVEhZyHgkrU1GtgJRqTAQVcYUO6zx/qQjRF8qgk+QAAAABJRU5ErkJggg=="-->
                                        <!--alt="销售服务支持" data-v-1525c382=""> <span-->
                                        <!--data-v-1525c382="">支持蚂蚁花呗</span></span></div>-->
                                        <!--<div class="col" data-v-1fd82d8e=""><span class="service-item"-->
                                        <!--data-v-1525c382=""-->
                                        <!--data-v-1fd82d8e=""><img-->
                                        <!--src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAZVJREFUOBGFk6tOA0EUhlkuEseWwCs0ISgMIQ0hYFAYWjx1mIbwABgcDoXCAgaFoqJJFaaEYEhAFgNvgFi+fzKzO52ZLSf598z5z2Uu52w2UyNFUeS4WkBa8g0GWZZJRzIbMhTYALfwQ7ANli20HsqnGNb1QkAbfIEjsBBGirO+Efo49BsbRxd8AHeVZJxIYlbAJ2hPBEHoOtpldcIxxSA2Bzp9dU0M3bszJS/pIkdPoPc0x1TldxC9STLbI5Vjc3N1TS3u09ZfLyZa2qQr9Llz2pwn7JYKLYFyNghcBJsuWFpFUNfgAIyAL8o1J/JJrbfAPck9GV6RPcwep3gQH8o8xA9Ycw4CH0m+wT5Dz6GbwBW5Yx2KxuVNOyYfG/4CqL1jcBhmy4YvH9v4IZLthz8B+6kitlDVfktoIF9Boy4p5InVdGuIq4G0xfSf6Rf5d7qJadjYbriBsXHqf9MuHRANqDjr09vt+kUy39CaAB31FKyDPnAzpu7sgBdwSXef0aVEhZyHgkrU1GtgJRqTAQVcYUO6zx/qQjRF8qgk+QAAAABJRU5ErkJggg=="-->
                                        <!--alt="销售服务支持" data-v-1525c382=""> <span-->
                                        <!--data-v-1525c382="">支付后可开发票</span></span></div>-->
                                        <!--</div>-->
                                    </div>
                                </div>
                                <el-dialog :modal-append-to-body='false'
                                        :visible.sync="dialogVisible"
                                        width="30%">
                                    <ul class="nav_title_ul" style="margin-top: -40px">
                                        <li class="nav_title_li"
                                            :class="nav_title==='购买' ? 'active_nav' : ''"
                                            @click="tab_nav('购买')"
                                        >
                                            购买
                                        </li>
                                        <li class="nav_title_li"
                                            :class="nav_title==='充值' ? 'active_nav' : ''"
                                            @click="tab_nav('充值')"
                                        >
                                            充值
                                        </li>
                                    </ul>
                                    <div class="stuff_div">
                                        <keep-alive>
                                            <component
                                                    :is="stuff_component_dict[nav_title]"
                                                    :data="plus_info"
                                                    :user_item_id="user_plus_id"
                                                    :type="'ujoyer.plus'"
                                                    :all_need_count="plus_info.price * 100" :recharge_amount="plus_info.price"></component>
                                        </keep-alive>
                                    </div>
                                    <!--<span slot="footer" class="dialog-footer">-->
                            <!--<span v-if="nav_title==='购买'"-->
                                  <!--style="font-size: 27px;float: left">购买：{{plus_info.title}}</span>-->
    <!--<el-button @click="dialogVisible = false">取 消</el-button>-->
    <!--<el-button type="primary" @click="confirm_buy(plus_info,user_all_copper_count,expense_all_copper_count,need_count)"-->
               <!--:disabled="user_all_copper_count<expense_all_copper_count">确 定</el-button>-->
  <!--</span>-->
                                </el-dialog>
                                <div class="container" data-v-4f72685e="" data-v-0329e14f="">
                                    <div class="row" data-v-4f72685e="">
                                        <div class="col" data-v-4f72685e="">
                                            <div class="card-wrap relative" data-v-4f72685e="">
                                                <div class="common-card" data-v-5369bc56="" data-v-4f72685e="">
                                                    <div class="card-inner" style="margin-top: 100px" data-v-5369bc56=""
                                                         data-v-4f72685e="">
                                                        <div class="card-box" data-v-5369bc56="" data-v-4f72685e="">
                                                            <div class="part left-part" data-v-5369bc56=""
                                                                 data-v-4f72685e=""><p
                                                                    class="price-info no-margin" data-v-5369bc56=""
                                                                    data-v-4f72685e=""><span data-v-5369bc56=""
                                                                                             data-v-4f72685e="">限时优惠价</span>
                                                                <span class="price" data-v-5369bc56=""
                                                                      data-v-4f72685e="">￥{{plus_info.price}}</span>
                                                                <!----> <span
                                                                        class="original-price" data-v-5369bc56=""
                                                                        data-v-4f72685e="">￥{{plus_info.real_price}}</span>
                                                            </p></div>
                                                            <div class="part right-part" data-v-5369bc56=""
                                                                 data-v-4f72685e=""><span class="remaining-quota"
                                                                                          data-v-5369bc56=""
                                                                                          data-v-4f72685e="">
                    本期剩余名额 <span class="bold" data-v-5369bc56="" data-v-4f72685e="">{{plus_info.remain}}</span></span>
                                                                <el-button v-if="!plus_info.is_business || (plus_info.is_ujoy_start && !plus_info.is_ujoyer)" type="button" class="btn btn-danger" @click="open">
                                                                    立即报名
                                                                </el-button>
                                                                <el-button v-if="plus_info.is_business || (plus_info.is_ujoy_start && plus_info.is_ujoyer)" type="button" class="btn btn-danger">
                                                                    开启团购
                                                                </el-button>
                                                                <el-button v-if="plus_info.is_business && plus_info.user_group_buy" type="button" class="btn btn-danger">
                                                                    我的团购
                                                                </el-button>
                                                                <a href="#plus_course" data-v-4f72685e="" class=""
                                                                   data-v-5369bc56="">
                                                                    <button type="button" class="btn btn-outline-danger"
                                                                            data-v-4f72685e="">
                                                                        查看课程详细大纲
                                                                    </button>
                                                                </a>
                                                            </div>
                                                        </div> <!----></div>
                                                </div>
                                                <div class="countdown-box font-12" data-v-4f72685e=""><span
                                                        data-v-4f72685e="">特价仅剩: </span>
                                                    <span data-v-4f72685e="" class="time-countdown">
  1天18时4分17秒
</span></div>
                                            </div>
                                        </div>
                                    </div> <!----></div>
                            </section>
                            <div class="sections-wrap" data-v-0329e14f="">
                                <section class="navbar-section" data-v-0329e14f="">
                                    <div class="navigation sections-nav font-21" data-v-29a4b88c="" data-v-0329e14f="">
                                        <div class="container" data-v-29a4b88c="">
                                            <div class="navbar-normall text-center" data-v-29a4b88c="">
                                                <div class="row" data-v-29a4b88c="">
                                                    <div class="col" data-v-29a4b88c="">
                                                        <div class="inline-block nav-item active" data-v-29a4b88c="">
                                                            套餐介绍
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <div class="navbar-top-fixed" style="display: none;" data-v-29a4b88c="">
                                                <div class="row navbar-inner-box" data-v-29a4b88c="">
                                                    <div class="col" data-v-29a4b88c="">
                                                        <div class="section-nav-list" data-v-29a4b88c="">
                                                            <div class="inline-block nav-item active"
                                                                 data-v-29a4b88c="">
                                                                套餐介绍
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div class="full-height col" data-v-29a4b88c="">
                                                        <div class="purchase-info relative full-height"
                                                             data-v-29a4b88c="">
                                                            <div class="box-left relative vertical-center font-18"
                                                                 data-v-29a4b88c=""><p class="price-info no-margin"
                                                                                       data-v-29a4b88c=""><span
                                                                    data-v-29a4b88c="">限时优惠价</span> <span class="price"
                                                                                                          data-v-29a4b88c="">￥1499</span>
                                                                <!----> <span class="original-price"
                                                                              data-v-29a4b88c="">￥2599</span></p></div>
                                                            <div class="box-right vertical-center font-16"
                                                                 data-v-29a4b88c="">
                                                                <div class="btn-group" data-v-29a4b88c="">
                                                                    <button type="button" class="btn btn-purchase btn-danger">
                                                                        立即报名
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>

                                <div id="introduction-section" data-v-0329e14f="">

                                    <section class="image-section image-section" data-v-0329e14f="">
                                        <div style="width: 1100px;margin: 0 auto" class="image-root" data-v-63867214="" data-v-0329e14f="" v-if="plus_info.introduction" v-html="plus_info.introduction">
                                        </div>
                                        <!--<div class="image-root" data-v-63867214="" data-v-0329e14f="">-->
                                            <!--<img :src="plus_info.course_image_url"/>-->
                                        <!--</div>-->
                                    </section>
                                </div>
                                 <!--<div class="font-21 navbar-normall text-center" data-v-29a4b88c="">-->
                                                <!--<div class="row" data-v-29a4b88c="">-->
                                                    <!--<div class="col" data-v-29a4b88c="">-->
                                                        <!--<div class="inline-block nav-item active" data-v-29a4b88c="">-->
                                                            <!--课程列表-->
                                                        <!--</div>-->
                                                    <!--</div>-->

                                                <!--</div>-->
                                            <!--</div>-->
                                <!--<div id="plus_course" style="height: 600px;width: 1100px;margin: 0 auto">-->
                                    <!--<div class="row">-->
                                        <!--<div class="panel !col-md-4">-->
                                            <!--<div class="top"></div>-->
                                            <!--<div class="block">-->
                                                <!--&lt;!&ndash;<div class="img"><img&ndash;&gt;-->
                                                <!--&lt;!&ndash;src="//edu-image.nosdn.127.net/ef7f1cf6a9f14b17a2486f3627f3eb09.png">&ndash;&gt;-->
                                                <!--&lt;!&ndash;</div>&ndash;&gt;-->
                                                <!--<div class="main-title">必选课程</div>-->
                                                <!--<div class="desc">选择此套餐必选的课程</div>-->
                                                <!--<router-link v-for="course in plus_info.plus_courses.necessary_courses"-->
                                                             <!--:key="course['id']" tag="a"-->
                                                             <!--:to="{ name: 'course', params: { id: course.id } }"-->
                                                             <!--target="_blank">-->
                                                    <!--<div class="list-item"><i class="point"></i>{{course.name}}-->
                                                    <!--</div>-->
                                                <!--</router-link>-->

                                                <!--&lt;!&ndash;<div class="btn">&ndash;&gt;-->
                                                <!--&lt;!&ndash;<a href="/eval_position" class="ux-btn th-bk-main">职业评估</a>&ndash;&gt;-->
                                                <!--&lt;!&ndash;</div>&ndash;&gt;-->

                                            <!--</div>-->
                                        <!--</div>-->
                                        <!--<div class="panel !col-md-4">-->
                                            <!--<div class="top"></div>-->
                                            <!--<div class="block">-->
                                                <!--&lt;!&ndash;<div class="img"><img&ndash;&gt;-->
                                                <!--&lt;!&ndash;src="//edu-image.nosdn.127.net/26669927ae4d434e80fb75528b890237.png">&ndash;&gt;-->
                                                <!--&lt;!&ndash;</div>&ndash;&gt;-->
                                                <!--<div class="main-title">组合课程</div>-->
                                                <!--<div class="desc">从以下几种组合任选{{plus_info.select_combined_max}}种</div>-->
                                                <!--<div v-for="c in plus_info.plus_courses.combined_courses" :key="c">-->
                                                    <!--<div class="second-title">{{c.combined_name}}</div>-->
                                                    <!--<router-link v-for="course in c.courses" :key="course.id" tag="a"-->
                                                                 <!--:to="{ name: 'course', params: { id: course.id } }"-->
                                                                 <!--target="_blank">-->
                                                        <!--<div class="list-item"><i class="point second"></i>{{course.name}}-->
                                                        <!--</div>-->
                                                    <!--</router-link>-->

                                                <!--</div>-->

                                                <!--&lt;!&ndash;<div class="btn">&ndash;&gt;-->
                                                <!--&lt;!&ndash;<a href="/skill/self_score/hr" class="ux-btn th-bk-main">技能评估</a>&ndash;&gt;-->
                                                <!--&lt;!&ndash;</div>&ndash;&gt;-->

                                            <!--</div>-->
                                        <!--</div>-->
                                        <!--<div class="panel !col-md-4">-->
                                            <!--<div class="top"></div>-->
                                            <!--<div class="block">-->
                                                <!--&lt;!&ndash;<div class="img"><img&ndash;&gt;-->
                                                <!--&lt;!&ndash;src="//edu-image.nosdn.127.net/b85ea16aa5cf41c488693cc1c863e91f.png">&ndash;&gt;-->
                                                <!--&lt;!&ndash;</div>&ndash;&gt;-->
                                                <!--<div class="main-title">自选课程</div>-->
                                                <!--<div class="desc">从以下课程任选{{plus_info.select_free_max}}门课程</div>-->
                                                <!--<router-link v-for="course in plus_info.plus_courses.free_courses"-->
                                                             <!--:key="course['id']" tag="a"-->
                                                             <!--:to="{ name: 'course', params: { id: course.id } }"-->
                                                             <!--target="_blank">-->
                                                    <!--<div class="list-item"><i class="point second"></i>{{course.name}}-->
                                                    <!--</div>-->
                                                <!--</router-link>-->

                                                <!--&lt;!&ndash;<div class="btn">&ndash;&gt;-->
                                                <!--&lt;!&ndash;<a href="/skill/self_score/common"&ndash;&gt;-->
                                                <!--&lt;!&ndash;class="ux-btn th-bk-main">能力评估</a>&ndash;&gt;-->
                                                <!--&lt;!&ndash;</div>&ndash;&gt;-->

                                            <!--</div>-->
                                        <!--</div>-->
                                        <!--&lt;!&ndash;<div class="clear"></div>&ndash;&gt;-->
                                    <!--</div>-->
                                <!--</div>-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
    import plusApi from '@/api/plus/plus.js'
    import accountApi from '@/api/account/account.js'
    import {mapState, mapActions} from 'vuex'
    import Expense from '@/components/pay_page/expense.vue'
    import Pay from '@/components/pay_page/pay.vue'


    export default {
        data() {
            return {
                countdown: '',
                nav_title: '购买',
                stuff_component_dict: {
                    '购买': 'Expense',
                    '充值': 'Pay'
                },
                dialogVisible: false,
                user_plus_id: 0,
            }
        },
        components: {
            Expense,
            Pay
        },
        computed: {
            ...mapState({
                plus_info: state => state.plus.plus_info,
                user_info: state => state.loginState.user_info,
                sign_on: state => state.loginState.sign_on
            }),
            user_all_copper_count: function () {
                return this.user_info.gold_count * 100 + this.user_info.silver_count * 10 + this.user_info.copper_count
            },
            expense_all_copper_count: function () {
                return this.plus_info.price * 100
            },
            // need_count: function () {
            //     let need_count = {
            //         'gold_count': 0,
            //         'silver_count': 0,
            //         'copper_count': 0,
            //     }
            //     let plus_all_count = this.plus_info.price * 100
            //     let user_copper_count = this.login_user_coin_count.copper_count
            //     if (user_copper_count <= plus_all_count) {
            //         need_count.copper_count = user_copper_count
            //     } else {
            //         need_count.copper_count = plus_all_count
            //         return need_count
            //     }
            //     plus_all_count -= need_count.copper_count
            //
            //     let user_silver_count = this.login_user_coin_count.silver_count
            //     if (user_silver_count * 10 <= plus_all_count) {
            //         need_count.silver_count = user_silver_count
            //     } else {
            //         need_count.silver_count = plus_all_count / 10
            //         return need_count
            //     }
            //     plus_all_count -= need_count.silver_count * 10
            //
            //     let user_gold_count = this.login_user_coin_count.gold_count
            //     if (user_gold_count * 100 <= plus_all_count) {
            //         need_count.gold_count = user_gold_count
            //     } else {
            //         need_count.gold_count = plus_all_count / 100
            //         return need_count
            //     }
            //     plus_all_count -= need_count.gold_count * 100
            //     return need_count
            //
            //
            // }
        },
        methods: {
            ...mapActions({
                get_plus_info: 'plus/get_plus_info',
                change_show_state: 'loginState/change_show_state',
            }),
            tab_nav(nav_title) {
                this.nav_title = nav_title
            },
            // confirm_buy(plus_info, user_all_copper_count, expense_all_copper_count, need_count) {
            //     let args = {
            //         'type': 'ujoyer.plus',
            //         'expense_item_id': plus_info.id,
            //         'quantity': 1,
            //         'price': plus_info.price,
            //         'state': 'process',
            //         'user_all_copper_count': user_all_copper_count,
            //         'expense_all_copper_count': expense_all_copper_count,
            //         'need_count': need_count,
            //         'user_plus_id': this.user_plus_id,
            //     }
            //     accountApi.create_expense_record(args).then((res) => {
            //         // console.log(res)
            //         let data = JSON.parse(res.data.result);
            //         if (data.code == 'success') {
            //             this.$message({
            //                 message: data.message,
            //                 type: 'success'
            //             });
            //         } else {
            //             this.$message({
            //                 message: data.message,
            //                 type: 'warning'
            //             });
            //         }
            //     })
            // },
            open() {
                if (!this.sign_on) {
                    this.change_show_state('on')
                } else {

                    plusApi.join_plus(this.$route.params.id).then((res) => {
                        if (res.data.code == 'success') {
                            this.dialogVisible = true
                            this.user_plus_id = res.data.user_plus_id
                        } else {
                            this.$message({
                                type: 'warning',
                                message: res.data.message
                            });
                        }
                    })
                    // this.$confirm('是否确认报名?', '提示', {
                    //     confirmButtonText: '确定',
                    //     cancelButtonText: '取消',
                    //     type: 'warning'
                    // }).then(() => {
                    //     plusApi.join_plus(this.$route.params.id).then((res) => {
                    //         console.log(res)
                    //         if (res.data.code == 'success') {
                    //             this.$message({
                    //                 type: 'success',
                    //                 message: res.data.message
                    //             });
                    //         } else {
                    //             this.$message({
                    //                 type: 'warning',
                    //                 message: res.data.message
                    //             });
                    //         }
                    //
                    //     })
                    // }).catch(() => {
                    //
                    // });
                }

            },
            dateFtt(fmt, date) { //author: meizz
                var o = {
                    "M+": date.getMonth() + 1, //月份
                    "d+": date.getDate(), //日
                    "h+": date.getHours(), //小时
                    "m+": date.getMinutes(), //分
                    "s+": date.getSeconds(), //秒
                    "q+": Math.floor((date.getMonth() + 3) / 3), //季度
                    "S": date.getMilliseconds() //毫秒
                };
                if (/(y+)/.test(fmt))
                    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
                for (var k in o)
                    if (new RegExp("(" + k + ")").test(fmt))
                        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
                return fmt;
            },
            get_countdown() {
                var startTime = this.dateFtt("yyyyMMddhhmmss", new Date());
                var endTime = this.plus_info.full_start_time;

                if (startTime.length < 14 || endTime.length < 14) {
                    alert('时间格式不正确');
                }
                if (parseInt(startTime) >= parseInt(endTime)) {
                    this.countdown = '已开课'
                } else {
                    var startArr = [startTime.substring(0, 4), startTime.substring(4, 6), startTime.substring(6, 8), startTime.substring(8, 10), startTime.substring(10, 12), startTime.substring(12, 14)];//切分开始时间为数组
                    var endArr = [endTime.substring(0, 4), endTime.substring(4, 6), endTime.substring(6, 8), endTime.substring(8, 10), endTime.substring(10, 12), endTime.substring(12, 14)];//切分结束时间为数组
                    var dateStart = new Date(startArr[0], startArr[1], startArr[2], startArr[3], startArr[4], startArr[5]);//采用new Date(yyyy,mth,dd,hh,mm,ss);创建方式分别传入年月日时分秒
                    var dateEnd = new Date(endArr[0], endArr[1], endArr[2], endArr[3], endArr[4], endArr[5]);
                    var dateInterval = dateEnd.getTime() - dateStart.getTime() //获取时间差毫秒
                    //计算出相差天数
                    var days = Math.floor(dateInterval / (24 * 60 * 60 * 1000));

                    //计算小时数
                    var hourLevel = dateInterval % (24 * 60 * 60 * 1000);
                    var hours = Math.floor(hourLevel / (60 * 60 * 1000))
                    //计算分钟数
                    var minutesLevel = hourLevel % (60 * 60 * 1000);
                    var minutes = Math.floor(minutesLevel / (60 * 1000));
                    //计算秒数
                    var seconds = Math.round((minutesLevel % (60 * 1000)) / 1000);
                    // console.log("时间差是: " + days + "天, " + hours + "小时, " + minutes + "分钟, " + seconds + "秒")
                    this.countdown = days + "天" + hours + "时" + minutes + "分" + seconds + "秒"
                }

            }
        },
        mounted() {
            let plusId = this.$route.params.id
            this.get_plus_info(plusId)

            setInterval(this.get_countdown, 1000);

        }
    }

</script>
<style type="text/css" scoped>
    @import '../../assets/css/plus1.css';
    @import '../../assets/css/plus2.css';

    .nav_title_ul {
        display: flex;
        border-bottom: 1px solid #eee;
        margin-bottom: 10px;
    }

    .nav_title_li {
        font-size: 16px;
        padding: 3px 5px;
        padding-bottom: 7px;
        margin-right: 25px;
        margin-bottom: -1px;
        border-bottom: 1px solid #eee;
        cursor: pointer;
    }

    .active_nav {
        border-bottom-color: #66CCFF;;
    }

    .plus_div {
        margin-top: -90px;
    }

    .second-title {
        border-bottom: 2px dashed #dcdcdc
    }

    .row {
        display: -webkit-box;
        display: flex;
        flex-wrap: wrap;
        margin-right: -15px;
        margin-left: -15px;
    }

    .panel {
        width: 320px;
        height: 550px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        position: relative;
        -webkit-transition: all 0.2s linear 0s;
        transition: all 0.2s linear 0s;
        margin: 25px;
        background-color: #fff;
    }

    .panel .top {
        -webkit-transition: all 0.2s linear 0s;
        transition: all 0.2s linear 0s;
        position: absolute;
        width: 100%;
        height: 3px;
        background: transparent;
    }

    .panel .block {
        width: 100%;
        height: 100%;
        padding: 0 18px 0 18px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }

    .panel .block .img {
        width: 125px;
        height: 103px;
        margin: 27px auto 3px auto;
    }

    .panel .block .main-title {
        -webkit-transition: all 0.2s linear 0s;
        transition: all 0.2s linear 0s;
        font-family: -apple-system, PingFang SC, "Microsoft YaHei", MicrosoftYaHei, "Arial", "Hiragino Sans GB", \5fae\8f6f\96c5\9ed1, "Helvetica", "sans-serif";
        font-size: 20px;
        color: #333;
        line-height: 18px;
        margin: 8px 10px;
        text-align: center;
        margin-top: 27px;
        margin-bottom: 19px;
    }

    .panel .block .desc {
        font-family: -apple-system, PingFang SC, "Microsoft YaHei", MicrosoftYaHei, "Arial", "Hiragino Sans GB", \5fae\8f6f\96c5\9ed1, "Helvetica", "sans-serif";
        font-size: 14px;
        color: #999;
        line-height: 22px;
        margin-bottom: 10px;
        text-align: center;
    }

    .panel .block .list-item {
        font-family: -apple-system, PingFang SC, "Microsoft YaHei", MicrosoftYaHei, "Arial", "Hiragino Sans GB", \5fae\8f6f\96c5\9ed1, "Helvetica", "sans-serif";
        font-size: 14px;
        color: #666;
        line-height: 25px;
        margin-left: 50px;
    }

    .panel .block .list-item .point {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #578BFF;
        display: inline-block;
        margin-right: 8px;
        vertical-align: middle;
    }

    .panel .block .list-item .point.second {
        background: #FF9C00;
    }

    .panel .block .btn {
        position: absolute;
        bottom: 32px;
        text-align: center;
        width: 284px;
    }

    .ux-btn {
        -webkit-appearance: none;
        margin: 0;
        overflow: visible;
        text-transform: none;
        text-decoration: none;
        cursor: pointer;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        display: inline-block;
        vertical-align: middle;
        text-align: center;
        padding: 0 12px;
        height: 34px;
        line-height: 34px;
        border-width: 1px;
        border-style: solid;
        font-size: 14px;
        border-radius: 2px;
    }

    .panel .btn .ux-btn.th-bk-main {
        -webkit-transition: all 0.2s linear 0s;
        transition: all 0.2s linear 0s;
        color: #578BFF;
        border: solid 1px #578BFF;
        border-radius: 2px;
        font-family: -apple-system, PingFang SC, "Microsoft YaHei", MicrosoftYaHei, "Arial", "Hiragino Sans GB", \5fae\8f6f\96c5\9ed1, "Helvetica", "sans-serif";
        font-size: 16px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        height: auto;
        line-height: initial;
        background: #fff;
        padding: 11px 40px;
    }

    .panel:hover {
        -webkit-box-shadow: 0 2px 35px 0 rgba(118, 154, 235, 0.25);
        box-shadow: 0 2px 35px 0 rgba(118, 154, 235, 0.25);
    }

    .panel:hover .top {
        background: #578BFF;
    }

    .panel:hover .block .main-title {
        color: #578BFF;
    }

    .panel:hover .block .btn .ux-btn.th-bk-main {
        color: #fff;
        background: #578bff;
    }

    .panel:hover .block .btn .ux-btn.th-bk-main {
        color: #fff;
        background: #578bff;
    }
</style>
